"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const material_1 = require("@mui/material");
const ResourceRow_1 = __importDefault(require("components/ResourceRegister/ResourceRow"));
const styles_1 = require("components/ResourceRegister/styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.treeNodeRowStyles);
const TreeNodeRow = ({ item, rowIndex, isChild = false, dataDictionary, onSave, onDelete, onSelect, selectedItems, onRemoveNewItem, getCategoryByID, setDialog, editingProps, narrowMode = false, disabled = false, expandForSearch = false, }) => {
    var _a;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(expandForSearch);
    const { classes } = useStyles();
    (0, react_1.useEffect)(() => {
        setIsExpanded(expandForSearch);
    }, [expandForSearch]);
    const handleExpandCollapse = () => {
        setIsExpanded((prev) => !prev);
    };
    const sharedProps = (data, isChildren, index) => ({
        item: data,
        isChild: isChildren,
        rowIndex: index,
        narrowMode,
        dataDictionary,
        onSave,
        onDelete,
        onSelect,
        selectedItems,
        onRemoveNewItem,
        getCategoryByID,
        setDialog,
        editingProps,
    });
    return (<material_1.List dense key={item.id} className={classes.listContainer}>
      <ResourceRow_1.default isExpanded={isExpanded} isParent={Boolean(item.children)} onCollapse={handleExpandCollapse} {...sharedProps(item, isChild, rowIndex)} disabled={disabled}/>
      {isExpanded && (<material_1.Collapse in={isExpanded} className={(0, classnames_1.default)(classes.collapseContainer, narrowMode ? 'narrowMode' : '')}>
          {(_a = item.children) === null || _a === void 0 ? void 0 : _a.map((child, childIndex) => (<TreeNodeRow key={child.id} {...sharedProps(child, true, [...rowIndex, childIndex + 1])} disabled={(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.has(item.id)) || disabled}/>))}
        </material_1.Collapse>)}
    </material_1.List>);
};
exports.default = TreeNodeRow;
